import {
  Box,
  Button,
  Card,
  Flex,
  Grid,
  Heading,
  IconButton,
  Stack,
  VStack,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import Loader from "../../utils/Loader/Loader";
import { getHostDomain } from "../../utils/utils";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import ActualFormAfterConfiguration from "./ActualFormAfterConfiguration";
import AutomatedWhatsappMessageForField from "./AuthomatedFollowUp";
import ConfigurationForm from "./ConfigurationForm";
import CreateFormGuide from "./CreateFormGuide";
import DetailsForm from "./DetaillsForm";
import useConfigureForm from "./useConfigureForm";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function ConfigureForms() {
  const baseUrl = getHostDomain();
  const navigate = useNavigate();
  const {
    fieldsForm,
    attributesForm,
    fields,
    formDetailsForm,
    onSetFields,
    status: formLoadStatus,
  } = useConfigureForm();
  const { reset: resetFormDetails, watch: watchFormDetailsForm } =
    formDetailsForm;
  const formLoading = formLoadStatus === "loading";
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
    getValues,
  } = fieldsForm;
  const [selectedField, setSelectedField] = useState(null);
  const resetFieldsForm = () =>
    reset({
      type: "text",
      description: "",
      label: "",
      name: "",
      privacy_content_url: "",
      options: [],
    });

  const onAddField = (newField) => {
    if (selectedField) {
      onSetFields((prevFields) =>
        prevFields.map((prevField) =>
          prevField.name === selectedField.name ? newField : prevField
        )
      );
      resetFieldsForm();
      return;
    }
    if (fields.find((field) => field.name === newField.name)) {
      toast.error("Two fields with same name cannot be created");
      return;
    }
    resetFieldsForm();
    onSetFields([...fields, newField]);
  };
  const onRemoveField = () => {
    if (!selectedField) return;
    onSetFields((prevFields) =>
      prevFields.filter((prevField) => prevField.name !== selectedField?.name)
    );
    setSelectedField(null);
    resetFieldsForm();
  };
  const onSetFormFields = (updatedFormFields) => {
    onSetFields(updatedFormFields);
  };
  const onSubmit = handleSubmit((data) => {
    onAddField(data);
    if (selectedField) setSelectedField(null);
  });
  const onSelectFieldFromListOfFields = (field) => {
    setSelectedField(field);
    reset(field);
  };

  const { formId } = useParams();
  const [status, setStatus] = useState("idle");
  const onUpdateForm = async () => {
    if (!fields.length) {
      toast.error("Form cannot be saved without fields !");
      return;
    }
    try {
      setStatus("loading");
      await fetchController(baseUrl + `/api/v1/form/${formId}`, "PUT", {
        form_type: formDetailsForm.getValues("type"),
        webhook_id: formDetailsForm.getValues("webhook_id") || null,
        name: formDetailsForm.getValues("name"),
        fields: fields.map((field) =>
          field.type === "select"
            ? {
                ...field,
                options: field.options.map((field) => field.option),
              }
            : field
        ),
        attributes: {
          text: attributesForm.getValues("followUpText"),
          automated_follow_up: attributesForm.getValues("automate"),
          contact_field: attributesForm.getValues("contactField"),
          channel: attributesForm.getValues("automate_type"),
          submit_label: watchFormDetailsForm("attributes.submit_label"),
          twilio_auth:
            attributesForm.getValues("automate_type") === "sms"
              ? attributesForm.getValues("twilio_auth")
              : undefined,
          phone_number:
            attributesForm.getValues("automate_type") === "sms"
              ? attributesForm.getValues("phone_number")
              : undefined,
          sid:
            attributesForm.getValues("automate_type") === "sms"
              ? attributesForm.getValues("sid")
              : undefined,
          send_me_too: attributesForm.getValues("should_send_me_too")
            ? attributesForm.getValues("send_me_too")
            : undefined,
          mandatory_submission: attributesForm.getValues(
            "mandatory_submission"
          ),
        },
        trigger_instructions: formDetailsForm.getValues("triggerInstructions"),
        org_id: null,

        contact_mapping: {
          ...getValues("contact_mapping"),
        },
      });
      setStatus("success");
      toast.info("Form updated !");
    } catch (error) {
      toast.error("Some error occured");
    } finally {
      setStatus("idle");
    }
  };
  const onCreateNewForm = async () => {
    if (!fields.length) {
      toast.error("Form cannot be saved without fields !");
      return;
    }
    try {
      setStatus("loading");
      await fetchController(baseUrl + `/api/v1/form`, "POST", {
        form_type: formDetailsForm.getValues("type"),
        name: formDetailsForm.getValues("name"),
        webhook_id: formDetailsForm.getValues("webhook_id") || null,
        fields: fields.map((field) =>
          field.type === "select"
            ? {
                ...field,
                options: field.options.map((field) => field.option),
              }
            : field
        ),
        trigger_instructions: formDetailsForm.getValues("triggerInstructions"),
        attributes: {
          text: attributesForm.getValues("followUpText"),
          automated_follow_up: attributesForm.getValues("automate"),
          contact_field: attributesForm.getValues("contactField"),
          submit_label: watchFormDetailsForm("attributes.submit_label"),
          channel: attributesForm.getValues("automate_type"),
          twilio_auth:
            attributesForm.getValues("automate_type") === "sms"
              ? attributesForm.getValues("twilio_auth")
              : undefined,
          phone_number:
            attributesForm.getValues("automate_type") === "sms"
              ? attributesForm.getValues("phone_number")
              : undefined,
          sid:
            attributesForm.getValues("automate_type") === "sms"
              ? attributesForm.getValues("sid")
              : undefined,
          send_me_too: attributesForm.getValues("should_send_me_too")
            ? attributesForm.getValues("send_me_too")
            : undefined,
          mandatory_submission: attributesForm.getValues(
            "mandatory_submission"
          ),
        },
        org_id: null,
        submit_label: watchFormDetailsForm("submitLabel"),
      });
      resetFieldsForm();
      resetFormDetails();
      onSetFields([]);
      setStatus("success");
      toast.success("Form created !");
    } catch (error) {
      toast.error("Some error occured");
    } finally {
      setStatus("idle");
    }
  };
  const [createFormTourVisibility, setCreateFormTourVisibility] = useState(
    localStorage.getItem("createFormTourVisibility") ? false : true
  );
  const onCloseTour = () => {
    localStorage.setItem("createFormTourVisibility", false);
    setCreateFormTourVisibility(false);
  };
  const isFormSubmitting = status === "loading";
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme, cardBg: bg } = agency;
  return (
      <VStack h="100%" spacing={2} borderRadius="md">
        <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" py={2}>
            <IconButton
              icon={<IoMdArrowRoundBack />}
              variant="outline"
              size="sm"
              onClick={() => navigate(-1)}
            />
            <Heading color={textColor} fontSize="xl">
              {formId ? "Update the form" : "Add a new form"}
            </Heading>
            {!formId ? <CreateFormGuide onCloseTour={onCloseTour} /> : null}
          </Flex>

          <form
            onSubmit={(e) => { e.preventDefault(); attributesForm.handleSubmit(
              formId ? onUpdateForm : onCreateNewForm
            )(); }}
            style={{ width: "100%" }}
          >
            <Flex w={"100%"} justifyContent={"flex-end"} alignItems={"center"}>
              <Button
                isDisabled={!fields.length}
                isLoading={formLoading || isFormSubmitting}
                type="button"
                onClick={() => attributesForm.handleSubmit(formId ? onUpdateForm : onCreateNewForm)()}
                colorScheme={buttonColorScheme}
              >
                {formId ? "Update form" : "Create Form"}
              </Button>
            </Flex>
          </form>

          <Card p={4} h={"100%"} w={"100%"} overflowY={"auto"}>
            <Stack
              direction="column"
              justifyContent={"space-between"}
              spacing={2}
              h={"100%"}
              w={"100%"}
              overflowY={"auto"}
            >
              <DetailsForm
                formDetailsForm={formDetailsForm}
                fields={fields}
                attributesForm={attributesForm}
              />

              <Stack direction={"column"} spacing={3} w={"100%"}>
                <Grid gap={3} gridTemplateColumns={"1fr 1fr"}>
                  <ConfigurationForm
                    errors={errors}
                    watch={watch}
                    setValue={setValue}
                    onRemoveField={onRemoveField}
                    selectedField={selectedField}
                    register={register}
                    handleSubmit={onSubmit}
                    control={control}
                  />
                  {fields.length ? (
                    <Box>
                      {formLoading ? (
                        <Loader />
                      ) : (
                        <ActualFormAfterConfiguration
                          fields={fields}
                          submitLabel={formDetailsForm.watch(
                            "attributes.submit_label"
                          )}
                          onSetFormFields={onSetFormFields}
                          selectedField={selectedField}
                          onSelectFieldFromListOfFields={
                            onSelectFieldFromListOfFields
                          }
                        />
                      )}
                    </Box>
                  ) : null}
                </Grid>
                <Box bg={bg} padding={3} borderRadius={"md"}>
                  <AutomatedWhatsappMessageForField
                    fields={fields}
                    automateForm={attributesForm}
                  />
                </Box>
              </Stack>
            </Stack>
          </Card>
        </Flex>
      </VStack>
  );
}
